module.exports = __webpack_public_path__ + "img/img_gfx@2x (2).916bddd0.png";